/**
 * Optimized Font Loader for Vite
 *
 * This file maps the font 'code' (identifier) used in constants/fonts.js
 * to the actual font files located in the /public/fonts/ directory.
 *
 * It injects @font-face rules dynamically to ensure the CSS font-family
 * exactly matches the codes used by Fabric.js and the rest of the application.
 */

const FONT_DIR = "/fonts/";

// Mapping based on src/constants/fonts.js and the /public/fonts directory inventory
const FONT_MAP = {
  // Common & Flat Cut
  Ubuntu: "Ubuntu-Regular.ttf",
  Abril_Fatface: "AbrilFatface-Regular.ttf",
  Acme: "Acme-Regular.ttf",
  Alba_Matter: "albam_.ttf",
  Alfa_Slab: "AlfaSlabOne-Regular.ttf",
  Americana: "GT-Americana_Bold_v2.ttf",
  Antique_Olive: "GT-AntiqueOliveMedium.ttf",
  Architectural: "GT-Architectural_v2.ttf",
  Arial: "GT-Arial.ttf",
  Arial_Bold: "GT-Arial_Bold_v2.ttf",
  Avant_Extra_Bold: "GT-Avant_Extra_Bold.ttf",
  Avant_Garde_Medium: "GT-Avant_Garde_Medium_v2.ttf",
  Bauhaus: "GT-Bauhaus.ttf",
  Benguiat: "GT-Benguiat_v2.ttf",
  Brush_Script: "GT-Brush_Script_v2.ttf",
  Caslon_Adbold: "GT-Caslon_Adbold_v2.ttf",
  Casual_Italic: "GT-Casual_Italic_Script.ttf",
  Century_Bold_Condensed: "GT-Century_Bold_Cond.ttf",
  Clarendon_Bold: "GT-Clarendon_Fortune_Bold_v2.ttf",
  Clarion: "GT-Clarion.ttf",
  Copperplate: "GT-Copperplate_v2.ttf",
  Clearview_Light: "GT-ClearviewOneLight.ttf",
  Clearview_Bold: "GT-ClearviewOneBold.ttf",
  Consort: "GT-Consort.ttf",
  Cookie: "Cookie-Regular.ttf",
  Country_Gothic: "GT-Country_Gothic.ttf",
  Creepster: "Creepster-Regular.ttf",
  Crushed: "Crushed-Regular.ttf",
  Eurostyle_Bold: "GT-Eurostyle_Bold_Ext_v2.ttf",
  Eurostyle: "GT-Eurostyle_Bold_Ext_v2.ttf",
  Friz_Quadrata: "GT-Friz_Quadrata_v2.ttf",
  Futura_Bold: "GT-Futura_Bold_v2.ttf",
  Futura_Condensed: "GT-Futura_Condensed_v2.ttf",
  Futura: "GT-Futura_v2.ttf",
  Garamond_Bold: "GT-Garamond_Bold_v2.ttf",
  Garamond_Regular: "GT-Garamond_Regular_v2.ttf",
  Gemco: "GT-Gemco.ttf",
  Goudy_Old_Style: "GT-Goudy_Old_Style.ttf",
  Helvetica_Bold: "GT-Helvetica_Bold_v2.ttf",
  Helvetica: "GT-Helvetica_v2.ttf",
  Helvetica_Medium_Condensed: "GT-Helvetica_Medium_Cond_v2.ttf",
  Herman_Italic: "GT-Herman_Italic.ttf",
  Holtwood_One: "HoltwoodOneSC-Regular.ttf",
  Holtwood_One_SC: "HoltwoodOneSC-Regular.ttf",
  Impact: "impact.ttf",
  Italicized_Script: "GT-Italicized_Script.ttf",
  Kavoon: "Kavoon-Regular.ttf",
  Kabel: "GT-Kabel_v2.ttf",
  Lato_Bold: "Lato-Bold.ttf",
  Lato: "Lato-Bold.ttf",
  Leckerli_One: "LeckerliOne-Regular.ttf",
  Lily_Script_One: "LilyScriptOne-Regular.ttf",
  Limelight: "Limelight-Regular.ttf",
  Lobster: "Lobster-Regular.ttf",
  Luckiest_Guy: "LuckiestGuy-Regular.ttf",
  Magneto: "magnetob.ttf",
  Mystery_Quest: "MysteryQuest-Regular.ttf",
  Nerko_One: "NerkoOne-Regular.ttf",
  Norwester: "norwester.otf",
  Nova_Square: "NovaSquare-Regular.ttf",
  Oleo_Script: "OleoScript-Bold.ttf",
  Optima: "GT-Optima_v2.ttf",
  Optima_Semibold: "GT-Optima_Semibold_v2.ttf",
  Oswald: "Oswald-Regular.ttf",
  Pacifico: "Pacifico-Regular.ttf",
  Palatino: "Merriweather-Regular.ttf",
  Palatino_Semibold: "Merriweather-Bold.ttf",
  Peralta: "Peralta-Regular.ttf",
  Perfaire: "GT-Perfaire.ttf",
  Permanent_Marker: "PermanentMarker-Regular.ttf",
  Ranchers: "Ranchers-Regular.ttf",
  Ribbon: "GT-Ribbon_v2.ttf",
  Ribbon_Condensed: "GT-Ribbon_Condensed_v2.ttf",
  Roboto_Slab: "RobotoSlab-SemiBold.ttf",
  Roman: "GT-Roman_v2.ttf",
  Rubik: "Rubik-Regular.ttf",
  Saira_Stencil: "SairaStencilOne-Regular.ttf",
  Salsa: "Salsa-Regular.ttf",
  Sarina: "Sarina-Regular.ttf",
  Satisfy: "Satisfy-Regular.ttf",
  Shojumaru: "Shojumaru-Regular.ttf",
  Short_Stack: "ShortStack-Regular.ttf",
  Sofia: "Sofia-Regular.ttf",
  Standard_Block: "GT-Standard_Block_v2.ttf",
  Standard_Block_Condensed: "GT-Standard_Block_Cond.ttf",
  Starjedi: "Starjedi.ttf",
  Times_New_Roman: "GT-Times_New_Roman_v2.ttf",
  Times_Roman: "GT-Times_Roman.ttf",
  Titillium_Web: "TitilliumWeb-Regular.ttf",
  Trajan_Bold: "GT-Trajan_Bold_v2.ttf",
  University_Roman: "GT-University_Roman.ttf",
  Victorian: "GT-Victorian.ttf",
  VT323: "VT323-Regular.ttf",

  // Additional Google Fonts from BL10/BL20 etc.
  Allerta_Stencil: "AllertaStencil-Regular.ttf",
  Amarillo: "Amarillo.ttf",
  Anton: "Anton-Regular.ttf",
  Antonio: "Antonio-Regular.ttf",
  Archivo_Narrow: "ArchivoNarrow-Medium.ttf",
  Audiowide: "Audiowide-Regular.ttf",
  Bebas: "BEBAS__.ttf",
  Balthazar: "Balthazar-Regular.ttf",
  Balthazer: "Balthazar-Regular.ttf",
  Bangers: "Bangers-Regular.ttf",
  Barlow_Condensed: "BarlowCondensed-Regular.ttf",
  Bebas_Neue: "BebasNeue-Regular.ttf",
  Berkshire_Swash: "BerkshireSwash-Regular.ttf",
  Bodoni_Italic: "LibreBodoni-SemiBoldItalic.ttf",
  Caprasimo: "Caprasimo-Regular.ttf",
  Century_Schoolbook: "Domine-SemiBold.ttf",
  Covered_By_Your_Grace: "CoveredByYourGrace-Regular.ttf",
  Delius_Swash_Caps: "DeliusSwashCaps-Regular.ttf",
  Domine: "Domine-SemiBold.ttf",
  Exo_Bold: "Exo2-Bold.ttf",
  Exo_2: "Exo2-Bold.ttf",
  Fjalla: "FjallaOne-Regular.ttf",
  Fjalla_One: "FjallaOne-Regular.ttf",
  Fontdiner_Swanky: "FontdinerSwanky-Regular.ttf",
  Freshman: "Freshman.ttf",
  Grand_Hotel: "GrandHotel-Regular.ttf",
  Highway_Gothic: "HighwayGothicD.otf",
  Inconsolata: "Inconsolata-Regular.ttf",
  Josefin_Sans: "JosefinSans-Bold.ttf",
  Jost: "Jost-Medium.ttf",
  Kanit: "Kanit-Regular.ttf",
  League_Gothic: "LeagueGothic-Regular.ttf",
  Merriweather: "Merriweather-Regular.ttf",
  Mystery_Quest: "MysteryQuest-Regular.ttf",
  Nature_Beauty: "Nature_Beauty.ttf",
  Nerko_One: "NerkoOne-Regular.ttf",
  Nova_Square: "NovaSquare-Regular.ttf",
  Oleo_Script: "OleoScript-Bold.ttf",
  Orbitron: "Orbitron-Regular.ttf",
  Oswald: "Oswald-Regular.ttf",
  Permanent_Marker: "PermanentMarker-Regular.ttf",
  Play: "Play-Regular.ttf",
  Poetsen_One: "PoetsenOne-Regular.ttf",
  Quicksand: "Quicksand-Regular.ttf",
  Roboto: "Roboto-Regular.ttf",
  Showcard_Gothic: "showg.ttf",
};

/**
 * Loads all fonts by injecting @font-face rules and preload links into the document.
 */
export const initFontLoading = () => {
  if (typeof document === "undefined") return;

  let css = "";
  Object.entries(FONT_MAP).forEach(([family, file]) => {
    const url = `${FONT_DIR}${file}`;
    const format = file.endsWith(".otf") ? "opentype" : "truetype";

    // Create @font-face rule
    css += `
      @font-face {
        font-family: '${family}';
        src: url('${url}') format('${format}');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
      }
    `;

    // Inject preload link for faster loading
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "font";
    link.href = url;
    link.crossOrigin = "anonymous";
    document.head.appendChild(link);
  });

  // Inject the CSS block
  const style = document.createElement("style");
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);

  // Inform the browser to load the fonts into the font cache
  if (document.fonts) {
    Object.keys(FONT_MAP).forEach((family) => {
      document.fonts.load(`1em "${family}"`);
    });
  }

  console.log(
    `[FontLoader] ${Object.keys(FONT_MAP).length} font families initialized.`,
  );
};

// Auto-run the font initialization
initFontLoading();

export default FONT_MAP;
